import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';

import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';
import { ListingDetailsSectionName } from '@listings/enums/listing-details-section-name';

export const listingGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const params = route.queryParams;

    if (params?.tab == null || ![ListingDetailsSectionName.Comments, ListingDetailsSectionName.Appointments].some(x => x === params.tab)) {
        return true;
    }

    const listingId: string = route.params.id;

    inject(RouteService).navigate(RpcRoute.Listing, { state: { tab: params.tab } }, null, listingId).catch(() => { });

    return false;
};